<template>
  <div
    class="upgrade-box"
    role="button" tabindex="0"
    @click="gotoSubscription()"
    @keydown.enter="gotoSubscription()"
    v-if="show">
    Your free trial will end on
    <strong>{{ expirationDate }}</strong>.
    Book&nbsp;a&nbsp;free&nbsp;one-on-one demo or view plan options.
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'trial-notification',

  components: {
  },

  computed: {
    expirationDate() {
      if (!this.site || !this.site.plan) return 'Today';
      if (!this.site.plan.expiration) return 'Today';
      return moment(this.site.plan.expiration).format('MMMM Do YYYY');
    },

    show() {
      return this.site && this.site.plan && this.site.plan.is_trial &&
          this.site.role === 'administrator';
    },
  },

  created() {
  },

  data() {
    return {
    };
  },

  methods: {
    gotoSubscription() {
      if (this.route) {
        this.route();
      } else {
        this.$router.Navigate.AdminSiteSettings(
          this.site.site_id,
          'subscription',
        );
      }
    },
  },

  props: {
    site: {
      type: Object,
      required: false,
    },
  },
};
</script>

<style lang="scss" scoped>
  div.upgrade-box {
    width: 100%;
    padding: 0.6em;
    background-color: #1f64f6;
    color: #fff;
    text-align: center;
    cursor: pointer;
    box-shadow: 2px 2px 5px rgba(0,0,0,0.4);
    border-radius: 0.2em;
  }
</style>
